<template>
  <AppLink class="cities-city-card" :to="link">
    <div class="cities-city-card__image-container">
      <img class="cities-city-card__image" :src="imageLink" :alt="imageAltText" loading="lazy" />
    </div>

    <div class="cities-city-card__title">
      <span v-if="countryCode"> {{ title }}&nbsp;<span class="cities-city-card__flag fi" :class="flagClass" /> </span>
      <span v-else>{{ title }}</span>
    </div>
    <div class="cities-city-card__counter">{{ t('excursions', excursionsCount) }}</div>
  </AppLink>
</template>

<script lang="ts" setup>
import { useI18n } from '@experience/i18n';
import { computed } from 'vue';

import ru from '../i18n/ru';

export interface Props {
  title: string;
  excursionsCount: number;
  imageLink: string;
  imageAltText?: string;
  link: string;
  countryCode: string;
}

const props = defineProps<Props>();

const flagClass = computed(() => `fi-${props.countryCode.toLowerCase()}`);

type MessageSchema = typeof ru;
const { t } = useI18n<{ message: MessageSchema }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});
</script>

<style lang="scss" scoped>
.cities-city-card {
  display: block;
  color: var(--alias-color-text-default);
  text-decoration: none;
}

.cities-city-card__image-container {
  aspect-ratio: 1/1;
  overflow: hidden;
  border-radius: var(--alias-radius-16);

  &:hover .cities-city-card__image {
    transform: scale(1.1);
  }

  @include adaptivity.mobile {
    border-radius: var(--alias-radius-12);
  }
}

.cities-city-card__image {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.cities-city-card__title {
  padding-top: var(--alias-space-4);

  @include typography.base-400-400-semi;
}

.cities-city-card__flag {
  display: inline-block;
  vertical-align: middle;
}

.cities-city-card__counter {
  @include typography.base-300-200-regular;
}
</style>
